// src/constants/cvdl.js
export const WHEEL_SLUG = 'cvdl-2026';

export const YEARS_OPTIONS = [
  { value: 'ESTUDIANTE', label: 'Estudiante' },
  { value: '0-2', label: '0–2 años' },
  { value: '3-7', label: '3–7 años' },
  { value: '8+', label: '8 o más' },
];

export const PRACTICE_OPTIONS = [
  { value: 'CLINICA_PROPIA', label: 'Clínica propia' },
  { value: 'EMPLEADO', label: 'Empleado/a' },
  { value: 'GUARDIAS', label: 'Guardias' },
  { value: 'GRANDES', label: 'Grandes animales' },
  { value: 'NO_EJERCE', label: 'Todavía no ejerzo' },
  { value: 'OTRO', label: 'Otra' },
];

export const INTEREST_OPTIONS = [
  { value: 'MEDICINA_FELINA', label: 'Medicina felina' },
  { value: 'MEDICINA_INTERNA', label: 'Medicina interna' },
  { value: 'CIRUGIA', label: 'Cirugía' },
  { value: 'IMAGENES', label: 'Imágenes' },
  { value: 'CARDIOLOGIA', label: 'Cardiología' },
  { value: 'DERMATOLOGIA', label: 'Dermatología' },
  { value: 'ONCOLOGIA', label: 'Oncología' },
  { value: 'EMERGENCIAS', label: 'Emergencias' },
  { value: 'ANESTESIOLOGIA', label: 'Anestesiología' },
  { value: 'NUTRICION', label: 'Nutrición' },
  { value: 'FISIOTERAPIA', label: 'Fisioterapia' },
  { value: 'NEUROLOGIA', label: 'Neurología' },
  { value: 'EXOTICOS', label: 'Exóticos' },
  { value: 'GRANDES_ANIMALES', label: 'Grandes animales' },
  { value: 'GESTION', label: 'Gestión de la clínica' },
  { value: 'OTRA', label: 'Otra' },
];

export const MAX_INTERESTS = 2;
export const IDLE_MS = 45000;
export const PRIZE_AUTO_RETURN_MS = 20000;